import React from 'react'

import PropTypes from 'prop-types'

import SetStatus from '../SetStatus'

import Styles from './index.scss'

const Action = props => (
  <div className="portlet light">
    <div className="portlet-title">
      <h4 className={Styles.productName}>{props.data.name}</h4>
    </div>
    <div className="portlet-body">
      <SetStatus />
    </div>
  </div>
  )

Action.propTypes = {
  data: PropTypes.shape({
    standard: PropTypes.object,
    name: PropTypes.string,
  }).isRequired,
}

export default Action
